import { ENV } from 'gatsby-env-variables'
import 'utils/loadAsyncSVG'
import isClient from '@mobi/utils/browser/isClient'

if (ENV === 'prod' && isClient()) {
  import(/* webpackChunkName: "thirdPartyScripts" */ 'utils/newrelic.js')
}
